"use client";

import { LinkProps } from "@/src/common-types";
import { Container } from "@/src/components/container";
import { BrandLogo } from "../../../brand-logo";
import { ContactBox, ContactBoxProps } from "./contact-box";
import { useStickyHeader } from "../../utils/use-sticky-header";
import { cn } from "@/src/utils/shadcn";
import { Navigation } from "../common/navigation";
import { headerData_en } from "@/data/en/layout/header/v1";
import { headerData_ar } from "@/data/ar/layout/header/v1";
import Link from "next/link";
import UserNav from "../../utils/user";
import { useEffect, useState } from "react";
import axiosConfig from "@/src/utils/axiosConfig.ts";
import { useRecoilState } from "recoil";
import { changeState, userState } from "@/src/recoil";

interface SubMenu {
  title: string;
  subMenuItems: LinkProps[];
}

export interface HeaderProps {
  contactInfo: ContactBoxProps;
  menuItems: (LinkProps | SubMenu)[];
  params: { lang: string };
}

export function Header({ params }: HeaderProps) {
  const isArabic = params.lang == "ar"
  const { menuItems, contactInfo } = isArabic ? headerData_ar : headerData_en;;
  const isSticky = useStickyHeader(700);
  const [user, setUser] = useRecoilState(userState);
  const [change, setChange] = useRecoilState(changeState);


  useEffect(() => {
    console.log('change', change);
    axiosConfig.get('/api/Auth/user').then((res) => {
      setUser(res.data.Data)
      console.log(res.data.Data)
    })
      .catch((err) => {
        console.log(err)
        setUser(null)
      })
  }, [change])



  return (
    <header
      className={cn(
        "left-0 right-0 top-0 z-99 mx-auto hidden w-full py-[26px] lg:block",
        isSticky
          ? "sticky-header fixed left-0 top-0 w-full animate-fadeInDown text-black bg-white/90 backdrop-blur-md [box-shadow:0px_0px_15px_10px_rgba(82,123,193,.1)] dark:bg-accent-900/90"
          : "absolute text-white bg-gradient-to-b from-black/80 via-black/50 to-transparent"
      )}
    >
      <Container>
        <div className="flex items-center justify-between gap-x-10">
          {/* Brand logo  */}
          {isSticky ? (
            <div className="flex-none">
              <BrandLogo params={params} />
            </div>
          ) : (
            <div className="flex-none  filter invert brightness-0 contrast-100">
              <BrandLogo params={params} />
            </div>
          )}

          {/* Navigation  */}
          {menuItems && menuItems.length > 0 && (
            <Navigation menuItems={menuItems} />
          )}

          {/* Contact box  */}
          <div className="px-3 relative">
            {user == null ?
              <Link href={isArabic ? "/ar/login" : "/en/login"} className="text-white">
                <div
                  className={
                    "rounded-lg px-4 py-2 hover:bg-slate-500 bg-primary text-white font-normal transition duration-300 ease-in-out hover:bg-primary-dark focus:ring-2 focus:ring-offset-2 focus:ring-primary-dark"
                  }
                >
                  <span className="flex align-center font-normal">
                    {
                      isArabic
                        ? "تسجيل الدخول"
                        : "Login"
                    }
                    <svg className="mt-1 mr-1" fill="#ffffff" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z" /></svg>
                  </span>
                </div>
              </Link>
              :
              <UserNav setChange={setChange} params={params} user={user} />
            }
          </div>
          {/* <ContactBox {...contactInfo} /> */}
        </div>
      </Container>
    </header>
  );
}
